import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Header from "./Header";
import Main1 from "./Main1";
import Films from "./Films";
import Experiences from "./Experiences";
import Cinescape from "./Cinescape";
import Events from "./Events";
import Footer from "./Footer";
import DateTime from "./DateTime";
import Select from "./Select";
import SeatType from "./SeatType";
import SeatMap from "./SeatMap";
import PageLoader from "./PageLoader";
 import Payment1 from "./Payment1";
import Knet from "./Knet";



import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket'
import ScrollToTop from './providers/ScrollToTop'

// Обёртка с лоадером и роутами
const AppLayout = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 1200); // 1.2 секунда лоадер
    return () => clearTimeout(timeout);
  }, [location]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="App">
           <ScrollToTop />
           <WebSocket />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Main1 />
              <Films />
              <Experiences />
              <Cinescape />
              <Events />
              <Footer />
            </>
          }
        />
        <Route
          path="/moviesessions"
          element={
            <>
              <Header />
              <DateTime />
              <Select />
              <Footer />
            </>
          }
        />
        <Route
          path="/map"
          element={
            <>
              <Header />
              <SeatMap />
              <Footer />
            </>
          }
        />
        <Route
          path="/type"
          element={
            <>
              <Header />
              <SeatType />
              <Footer />
            </>
          }
        />
           <Route
          path="/payment"
          element={
            <>
               
              <Payment1/>


            </>
            
          }
        />
          <Route path='/knet' element={<Knet />}/>
             {ThreeDSRoutes()}
      </Routes>
    </div>
  );
};

// Внешний компонент оборачивает всё в <Router>
const App = () => {
  return (
    <Router>
    
      <AppLayout />
    </Router>
  );
};

export default App;
